import(/* webpackMode: "eager", webpackExports: ["ActualitesClient"] */ "/vercel/path0/app/(frontend)/actualites/actualites-client.tsx");
